export default __webpack_public_path__ + "static/dealer-default-image-62bddf322a5494a0d6c298045149ff03.jpg";